export default function AuthBusinessDashboard({ contentData, initError, initLoader }) {
  return <div>This is Auth Business Dashboard page</div>;
}
